import { LOGIN_ROUTE_SUPER_ADMIN, LOGIN_ROUTE_AFFILIATE, LOGIN_ROUTE_CLIENT }  from '../configs/staticConfigs';
import { getUserGroupData } from './browserStorage';

export  const userGroupUrlCheck = (location) =>{
    let userGroupData = '';    
    if(location.pathname.includes(LOGIN_ROUTE_SUPER_ADMIN)){
        userGroupData  = getUserGroupData('super');
        if(userGroupData!==null){
            return userGroupData;
        }
    }else if(location.pathname.includes(LOGIN_ROUTE_AFFILIATE)){
        userGroupData  = getUserGroupData('affiliate');
        if(userGroupData!==null){
            return userGroupData;
        }
    }else if(location.pathname.includes(LOGIN_ROUTE_CLIENT)){
        userGroupData  = getUserGroupData('client');
        if(userGroupData!==null){
            return userGroupData;
        }
    }else{
        return undefined;
    }
};

export const getUserTimeZone = (location) =>{
    let userGroupData = userGroupUrlCheck(location);
    let timeZoneOffset = ''; 
    if(userGroupData!==undefined){
        timeZoneOffset = userGroupData.time_zone; 
    }
    return timeZoneOffset; 
}